import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { InvoiceService } from '../../services/invoice/invoice.service';

@Component({
	selector: 'pcm-admin-sup-invoice',
	templateUrl: './admin-sup-invoice.component.html',
	styleUrls: ['./admin-sup-invoice.component.scss']
})
export class AdminSupInvoiceComponent implements OnInit {

	supinvoiceData;
	canSubmit = false;

	constructor(private invoiceService: InvoiceService
	) { }

	ngOnInit() {
		this.canSubmit = false;
	}

	onSubmit(form: NgForm) {
		// if( !this.supinvoiceData.PONumber || !this.supinvoiceData.BillingEndDate || !this.supinvoiceData.BillingStartDate|| !this.supinvoiceData.InvoiceNumber || !this.supinvoiceData.InvoiceType){
		// 	console.log("Paylod has a bad case-sensitive format, Example:"+ "PONumber,BillingEndDate,BillingStartDate,InvoiceNumber,InvoiceType");
		// }else{
		// 	console.log('Invoice SUBMIT: ', this.supinvoiceData);
		// 	this.invoiceService.submitSupInvoice(this.supinvoiceData);
		// }
		console.log('Invoice SUBMIT: ', this.supinvoiceData);
		this.invoiceService.submitSupInvoice(this.supinvoiceData);
	}

	validateData() {
		// simple validation
		if (this.supinvoiceData && this.supinvoiceData !== '[]' && this.supinvoiceData !== '{}') {
			try {
				const jObj = JSON.parse(this.supinvoiceData);
				if (jObj) {
					this.canSubmit = true;
				}
			} catch (e) {
				this.canSubmit = false;
			}
		} else {
			this.canSubmit = false;
		}
	}

}
